exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-plan-table .td-requirement[data-v-38073c86],.action-plan-table .td-response[data-v-38073c86]{width:20%}.action-plan-table .td-completed[data-v-38073c86],.action-plan-table .td-target[data-v-38073c86]{width:15%}.action-plan-table .td-buttons[data-v-38073c86]{width:2%}.action-plan-table textarea[data-v-38073c86]{resize:vertical}.legend-table[data-v-38073c86]{border-spacing:0}.legend-table td[data-v-38073c86]{border:1px solid #000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38073c86","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/forms/FireRiskAssessment.vue
// module id = vwEl
// module chunks = 0